"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskOutputControlDataAttrib = void 0;
// todo: move in others used (reducer and switch mostly, maybe others--grep use of TaskOutputControlData reserved key)
var TaskOutputControlDataAttrib;
(function (TaskOutputControlDataAttrib) {
    TaskOutputControlDataAttrib["ExamSuiteBehaviorsRun"] = "ExamSuiteBehaviorsRun";
})(TaskOutputControlDataAttrib = exports.TaskOutputControlDataAttrib || (exports.TaskOutputControlDataAttrib = {}));
//# sourceMappingURL=task-control-data-attribs.js.map